import * as C from '../constants';

export default {
  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_SETTINGS_STATE_RESET](state, payload) {
    state.availableDomains = payload;
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_ITEMS_PENDING](state) {
    state.availableDomains = { ...state.availableDomains, loading: true, error: false, items: [] };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_SETTINGS_ITEMS_SUCCESS](state, payload) {
    state.availableDomains = {
      ...state.availableDomains,
      loading: false,
      error: false,
      items: payload,
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_ITEMS_FAILURE](state) {
    state.availableDomains = { ...state.availableDomains, loading: false, error: true, items: [] };
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_PENDING](state) {
    state.availableDomains.delete = {
      ...state.availableDomains.delete,
      deleting: true,
      error: false,
      success: false,
    };
  },

  /**
   * @param state
   * @param payload
   */
  [C.REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_SUCCESS](state, payload) {
    state.availableDomains = { ...state.availableDomains, items: payload };
    state.availableDomains.delete = {
      ...state.availableDomains.delete,
      deleting: false,
      error: false,
      success: true,
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_DELETE_AVAILABLE_DOMAIN_FAILURE](state) {
    state.availableDomains.delete = {
      ...state.availableDomains.delete,
      deleting: false,
      error: true,
      success: false,
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_PENDING](state) {
    state.availableDomains.add = {
      ...state.availableDomains.add,
      adding: true,
      error: false,
      success: false,
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_SUCCESS](state) {
    state.availableDomains.add = {
      ...state.availableDomains.add,
      adding: false,
      error: false,
      success: true,
    };
  },

  /**
   * @param state
   */
  [C.REVIEW_SETTINGS_ADD_AVAILABLE_DOMAIN_FAILURE](state) {
    state.availableDomains.add = {
      ...state.availableDomains.add,
      adding: false,
      error: true,
      success: false,
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/review-settings/mutations.js